module.exports = __webpack_public_path__ + "static/media/mono_mk2_panel.b2382747.png";